var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccesses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9825 33.7959C23.8601 32.5714 21.9213 32.4694 20.6968 33.5918C19.4723 34.7143 19.3703 36.6531 20.4927 37.8776L35.9009 54.6122C36.5131 55.2245 37.2274 55.6327 38.0438 55.6327C38.0438 55.6327 38.0438 55.6327 38.1458 55.6327C38.9621 55.6327 39.7785 55.3265 40.2887 54.7143L79.2682 15.8367C80.4927 14.6122 80.4927 12.6735 79.2682 11.551C78.0438 10.4286 76.105 10.3265 74.9825 11.551L38.2478 48.1837L24.9825 33.7959Z",
    fill: "#96D25A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5539 37.9796C76.8192 37.9796 75.4927 39.3061 75.4927 41.0408C75.4927 60.0204 59.9825 75.5306 41.0029 75.5306C22.0233 75.5306 6.51307 60.0204 6.51307 41.0408C6.51307 22.0612 22.0233 6.55102 41.0029 6.55102C42.7376 6.55102 44.0641 5.22449 44.0641 3.4898C44.0641 1.75511 42.7376 0.428574 41.0029 0.428574C18.6559 0.428574 0.390625 18.6939 0.390625 41.0408C0.390625 63.3878 18.6559 81.6531 41.0029 81.6531C63.3498 81.6531 81.6151 63.3878 81.6151 41.0408C81.6151 39.3061 80.2886 37.9796 78.5539 37.9796Z",
    fill: "#96D25A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesses);
export default __webpack_public_path__ + "static/media/successes.7264c722b721fc5bc18cee82fdb2dcf4.svg";
export { ForwardRef as ReactComponent };